export enum VariableType {
	Passphrase,
	KeyFile,
	Variable,
}
